import {
  IWizardStudentState,
  TWizardStepComponentEditable,
  WIZARD_STUDENT_STEPS_PATHS
} from "../../../interfaces";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import { AvatarUploader } from "../../../../AvatarUploader";
import { UserAPI } from "../../../../../API/userApi";
import { getStepErrorsFromResponse } from "../../../utils";
import { RcFile } from "antd/lib/upload/interface";
import { useTranslation } from "react-i18next";

const statePath = WIZARD_STUDENT_STEPS_PATHS.Avatar;
export const WizardStepAvatar: TWizardStepComponentEditable<IWizardStudentState> =
  forwardRef(({ state, readonly, viewonly }, ref) => {
    const [errors, setErrors] = useState<{ user_image: string } | null>(null);

    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const { t } = useTranslation("wizard");

    const save = () => {
      setErrors(null);
      if (!selectedFile && state[statePath]?.avatar_thumbnail_url) {
        return Promise.resolve(state);
      }
      return UserAPI.wizardStudentSaveAvatar({
        user_image: selectedFile as RcFile
      })
        .then((result) => {
          return {
            ...state,
            [statePath]: result
          };
        })
        .catch((e) => {
          const errors = getStepErrorsFromResponse(e) as {
            user_image: string;
          } | null;
          if (errors) {
            setErrors(errors);
          } else {
            setErrors({
              user_image:
                e?.response?.status === 413
                  ? t("steps.Avatar.toBig")
                  : t("steps.Avatar.uploadError")
            });
          }

          return Promise.reject(e);
        });
    };

    useImperativeHandle(ref, () => ({
      save: save
    }));

    return (
      <WizardStepAvatarView
        avatarThumbnailUrl={state[statePath]?.avatar_thumbnail_url}
        errors={errors}
        onFileChange={(file) => {
          setSelectedFile(file);
        }}
        readonly={readonly}
        viewonly={viewonly}
      />
    );
  });

export const WizardStepAvatarView: React.FC<{
  avatarThumbnailUrl?: string | null;
  onFileChange: (file: File | null) => void;
  errors: { user_image?: string } | null;
  readonly?: boolean;
  viewonly?: boolean;
}> = React.memo(
  ({ avatarThumbnailUrl, onFileChange, readonly, viewonly, errors }) => {
    const { t } = useTranslation("student");
    return (
      <div>
        <AvatarUploader
          initialImageUrl={
            avatarThumbnailUrl
              ? `${avatarThumbnailUrl}?rand=${Math.random()}`
              : undefined
          }
          onFileSelect={(file) => {
            onFileChange(file ?? null);
          }}
          readonly={readonly || viewonly}
        />
        {errors?.user_image && (
          <div style={{ color: "red" }}>{t("wizard.steps.Avatar.error")}</div>
        )}
      </div>
    );
  }
);
